import { Box } from '@mui/material';
import { useForm } from 'react-hook-form';
import uniqid from 'uniqid';
import { Kitchen } from '../../apiTypes';
import EditModal from '../../components/EditModal';
import FormTextField from '../../components/forms/FormTextField';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useLocale } from '../../contexts/locale.context';
import { deleteDoc, setDoc, updateDoc } from '../../utils/api';

type Props = {
  open: boolean;
  kitchen?: DbDocument<Kitchen> | null;
  onClose: () => void;
};

const EditKitchen = ({ kitchen, open, onClose }: Props) => {
  const { cafeSlug } = useAdmin();
  const { lang } = useLocale();

  const form = useForm<Kitchen>({
    mode: 'onChange',
    defaultValues: {
      name: kitchen?.name || '',
    },
  });

  const handleClose = () => {
    onClose();
    form.reset();
  };

  const saveChanges = (newKitchen: Kitchen) => {
    if (kitchen?.id) {
      updateDoc<Kitchen>(`cafes/${cafeSlug}/kitchens/${kitchen.id}`, newKitchen);
    } else {
      setDoc<Kitchen>(`cafes/${cafeSlug}/kitchens/${uniqid()}`, newKitchen);
    }

    handleClose();
  };

  const remove = async () => {
    if (kitchen?.id) {
      deleteDoc(`cafes/${cafeSlug}/kitchens/${kitchen.id}`);
      handleClose();
    }
  };

  return (
    <EditModal<Kitchen>
      title={t.cooking_place[lang]}
      open={open}
      onClose={handleClose}
      submitButton={kitchen ? t.save_changes[lang] : t.add[lang]}
      onSubmit={saveChanges}
      secondaryButton={kitchen ? t.remove[lang] : undefined}
      confirmText={t.remove_store_confirm[lang]}
      onSecondaryButtonClick={remove}
      form={form}
      size="xs"
    >
      <Box sx={{ py: 2, mb: 1 }}>
        <FormTextField name="name" label={t.name[lang]} rules={{ required: true }} fullWidth />
      </Box>
    </EditModal>
  );
};

export default EditKitchen;
